var map = {
	"./404-desktop.svg": 519,
	"./404.svg": 424,
	"./500-desktop.svg": 520,
	"./500.svg": 373,
	"./alert.svg": 521,
	"./alfabank.svg": 437,
	"./arrow-down.svg": 425,
	"./arrow-left.svg": 414,
	"./arrow-right-circle.svg": 522,
	"./arrow-right.svg": 429,
	"./arrow-slider-left.svg": 523,
	"./arrow-slider-right.svg": 524,
	"./back.svg": 438,
	"./bin.svg": 439,
	"./burger-menu.svg": 525,
	"./cart.svg": 274,
	"./catalog.svg": 374,
	"./checkbox-checked.svg": 440,
	"./chevron.svg": 375,
	"./clock.svg": 376,
	"./close-but.svg": 298,
	"./edit.svg": 526,
	"./facebook.svg": 527,
	"./favourite-active.svg": 419,
	"./favourite.svg": 420,
	"./favourites.svg": 528,
	"./fb.svg": 529,
	"./filters-mobile.svg": 441,
	"./filters.svg": 530,
	"./heart.svg": 531,
	"./icon-minus.svg": 430,
	"./icon-plus.svg": 431,
	"./insta.svg": 532,
	"./instagram.svg": 533,
	"./location.svg": 309,
	"./logo-desktop.svg": 534,
	"./logo.svg": 215,
	"./loop-white.svg": 377,
	"./loop.svg": 378,
	"./mastercard.svg": 442,
	"./mastercard_sc.svg": 443,
	"./menu-dots.svg": 535,
	"./mir.svg": 444,
	"./mir_sc.svg": 445,
	"./pagination-arrow-left.svg": 421,
	"./pagination-arrow-right.svg": 422,
	"./payment_failed.svg": 432,
	"./payment_success.svg": 433,
	"./personal-account.svg": 536,
	"./phone.svg": 216,
	"./profile.svg": 275,
	"./provizor.svg": 379,
	"./select-arrow-down.svg": 446,
	"./thanks.svg": 434,
	"./tree-desktop.svg": 380,
	"./tree.svg": 381,
	"./visa.svg": 447,
	"./visa_sc.svg": 448,
	"./warning.svg": 449,
	"./zhdun.svg": 450
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 273;